import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';

export const Card = styled.div`
  padding: ${theme('spacing.sm')};
  border-radius: ${theme('borderRadius.sm')};
  box-shadow: ${theme('shadow.sm')};
  background-color: ${palette('bgCard')};

  ${({ onClick }) =>
    onClick
      ? css`
          border: 1px solid ${palette('borderCard')};
          transition: ${theme('transition')};
          cursor: pointer;

          &:hover {
            box-shadow: ${theme('shadow.xs')};
          }
        `
      : ''}
`;
